import { Box, useTranslation } from '@common';
import { service } from '../service';
import styles from '../style.module.less';
import { DragItem, Highlighter } from '../../component';
import { usePrimaryColor } from '../../hooks';
import { GridDesigner } from './grid-designer';
import { QuestionnaireModal } from './modal';
import { CustomInputModal } from './cell-modal';
import type { ReactElement } from 'react';
import type { ShotEyesGridProps } from './types';

export function ShotEyesGridDesignMode(props: ShotEyesGridProps): ReactElement {
  const [t] = useTranslation();
  const { rgbColor } = usePrimaryColor();
  // 拖拽时显示组件
  if (props.name == null) {
    return (
      <DragItem title={t('ShotEyesGrid')} />
    );
  }


  // 主题色
  const activeStyle = props.active === true ? {
    boxShadow: `${rgbColor} 0 0 3px`
  } : {};
  return (
    <Box
      className={styles.designBox}
      style={{ ...activeStyle, paddingLeft: service.getIndent(props.path) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={styles.input}>
        <GridDesigner
          {...props}
          type='setting'
          settings={(<QuestionnaireModal />)}
          cellModal={(<CustomInputModal option={[]} />)}
          onChange={value => props.onPropsChange?.(value)}
        />
      </Box>
    </Box>
  );
}
